export enum LiveContextShowMode {
  MEDIA_ONLY = 'mediaOnly',
  SPEAKER_ONLY = 'speakerOnly',
  BOTH = 'both',
}
